import { markPreloaded, markLoaded, isSceneLoaded, areAssetsLoaded, areAssetsPreloaded,
  markRenderedScene, markRenderingScene, getSceneId, getScenePhase, SCENE_PHASES } from '../modules/sceneIO';
import { getEvalSceneGraph, virtualCameraId, vrCameraId, virtualTargetId, merge } from '../modules/sceneGraph';
import { incrementTime } from '../modules/animation';

const defaultNodeFilter = (n) => true;

const defaultFns = {
  onLoad() {},

  postTranslate() {},

  handleStateChanges() {},
};

export function createTranslator(store, initTranslator, context) {
  let api = {};
  let translator = initTranslator(store, context, api);
  let nodeFilter = defaultNodeFilter;

  let view = null;
  let player = store.get('player');

  let translatedSceneId;

  let translatedVersion = null;
  let translatedNodes = {};
  let renderingMode = store.getIn(['player', 'renderingMode']);
  let vrDisplay;

  function translateNodes(sceneId) {
    const sceneGraph = getEvalSceneGraph(store);

    if (translatedVersion === sceneGraph._ev) return 0;

    const newTranslatedNodes = {};

    //console.log('translate from', translatedVersion, 'to', sceneGraph._ev); //, translatedNodes);

    let numUpdated = 0;

    function translateNode(id) {
      const node = sceneGraph.nodes[id];
      if (!node) return;
      const result = sceneGraph.evaluatedNodes[id];
      const translated = translatedNodes[id];

      if (!translated || translated._v !== result._v || translated._ev !== result._ev) {
        //console.log('translate: ', translatedNodes[id], {_v: result._v, _ev: result._ev}, node.name);
        translator.translate(id, result, node);
        numUpdated += 1;
      }

      newTranslatedNodes[id] = { _v: result._v, _ev: result._ev };

      for (let childId of node.children) {
        translateNode(childId);
      }
    }

    translateNode(sceneId);

    if (sceneGraph.nodes[virtualCameraId]) translateNode(virtualCameraId);
    if (sceneGraph.nodes[vrCameraId]) translateNode(vrCameraId);

    for (const id of Object.keys(translatedNodes)) {
      if (!newTranslatedNodes[id]) {
        translator.deleteNode(id);
      }
    }

    translatedNodes = newTranslatedNodes;
    translatedVersion = sceneGraph._ev;

    return numUpdated;
  }

  function doUpdate() {
  }

  function reset() {
    translator.reset();
    for (const id of Object.keys(translatedNodes)) {
      translator.deleteNode(id);
    }

    translatedVersion = null;
    translatedNodes = {};
  }

  return Object.assign({}, defaultFns, translator, {
    update: function (options={}) {
      const sceneId = getSceneId(store);
      const scenePhase = getScenePhase(store);
      if (!sceneId) {
        translatedSceneId = null;
        return;
      }

      if (sceneId !== translatedSceneId || scenePhase < SCENE_PHASES.RENDERING) {
        reset();
        translatedSceneId = sceneId;
      }

      // console.log('translator do update');
      const numUpdated = translateNodes(sceneId);
      //console.log('numUpdated: ', numUpdated);
      const rendering = scenePhase >= SCENE_PHASES.RENDERING;
      const preloaded = scenePhase >= SCENE_PHASES.PRELOADING;
      const loaded = scenePhase >= SCENE_PHASES.LOADED;
      const rendered = scenePhase >= SCENE_PHASES.RENDERED;

      //console.log('numUpdated', numUpdated, 'assetsLoaded', areAssetsLoaded(store), 'rendering', rendering, 'preloaded', preloaded, 'loaded', loaded);

      if (!rendering && numUpdated) {
        store.dispatch(markRenderingScene());
      }

      if (loaded && !rendered) {
        store.dispatch(markRenderedScene());
      }

      if (!loaded && preloaded && areAssetsLoaded(store)) {
        translator.onLoad();
        store.dispatch(markLoaded());
      }

      if (!preloaded && areAssetsPreloaded(store)) {
        store.dispatch(markPreloaded());
      }

      if (preloaded) translator.postTranslate();

      store.dispatch(incrementTime());
    },
  });
};



// WEBPACK FOOTER //
// ./src/translators/translator.js